// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8e340ec7","455":"36e41881","644":"11afdcee"}[chunkId] + ".chunk.js";
};